import Card from "./Card";
import EditButton from "../components/buttons/EditButton";
import Filters from "./Filters";
import InlineTextInput from "./inputs/InlineTextInput";
import React from "react";
import ResponsiveGridWithWebsocket from "../components/list/ResponsiveGridWithWebsocket";
import ResponsiveList from "../components/list/ResponsiveList";
import { TextField } from "react-admin";
import { useRowHighlightTracking } from "../components/utils/useRowHighlightTracking";

const List = (props) => {
  const { "language-message": highlightedLanguageMessageIds = [] } =
    useRowHighlightTracking();

  const rowClass = (record) => {
    const id = record.id?.toString();
    if (highlightedLanguageMessageIds.includes(id)) return "modifyResource";
    return "";
  };

  return (
    <ResponsiveList
      {...props}
      type="table"
      split
      perPage={10}
      filters={<Filters />}
      exporter={false}
      key={highlightedLanguageMessageIds.join(",")}
    >
      <ResponsiveGridWithWebsocket
        rowBreakpoint="sm"
        cardContent={<Card />}
        target="language-message"
        rowClasses={rowClass}
      >
        <TextField source="id" />
        <TextField source="language.code" label="language_id" />
        <TextField source="code" variant="body2" />
        <InlineTextInput source="text" minWidth={350} />
        <EditButton />
      </ResponsiveGridWithWebsocket>
    </ResponsiveList>
  );
};
export default List;
